import React from 'react';
import { Form, Radio } from 'antd';

import { Gender, GenderToText } from '../../../models';

type GenderInputProps = {
  name: string;
  label: string;
  value?: Gender;
  required?: boolean;
  disabled?: boolean;
  onChange?: (gender: Gender) => void;
};

export function GenderInput(props: GenderInputProps) {
  const handleChange = (value: Gender) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };
  return (
    <Form.Item name={props.name} label={props.label} rules={[{ required: props.required, message: `${props.label} is required` }]}>
      <Radio.Group onChange={(event) => handleChange(event.target.value)} disabled={props.disabled}>
        <Radio value={Gender.Female}>{GenderToText(Gender.Female)}</Radio>
        <Radio value={Gender.Male}>{GenderToText(Gender.Male)}</Radio>
        <Radio value={Gender.Other}>{GenderToText(Gender.Other)}</Radio>
        <Radio value={Gender.PreferNotToSay}>{GenderToText(Gender.PreferNotToSay)}</Radio>
      </Radio.Group>
    </Form.Item>
  );
}
